import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import AppModal from '@buncha/common/components/CustomModal/AppModal';
import {HomeScreens} from '@buncha/home/navigation/types';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

interface CancelOrderModalProps {
  onClose: () => void;
  onSubmit: () => void;
  disableNavigation?: boolean;
  disableState?: boolean;
  open: boolean;
  loading: boolean;
  hideTopCta?: boolean;
  title?: string;
  subTitle?: string;
}
const CancelOrderModal: React.FC<CancelOrderModalProps> = props => {
  const muliFontTheme = useFontTheme('mortise');
  const theme = useColorThemeType();
  const {title, body, button} =
    useGetLocale(Modules.B2B, HomeScreens.B2B) ?? {};
  return (
    <AppModal
      isOpen={props?.open}
      onClose={props?.onClose}
      hideTopCta={props?.hideTopCta}
      topCTAHandelr={props?.onSubmit}
      bottomCTAHandelr={props.onClose}
      title={props?.title ?? title?.itemsReturned}
      subTitle={props?.subTitle ?? body?.verifyItemsReturn}
      ctaBottomTitle={button?.back}
      titleStyle={{fontFamily: muliFontTheme[700].normal, ...styles.titleTypo}}
      ctaTopTitle={button?.returned}
      topCTAColor={theme?.background.red[100]}
      loading={props?.loading}
    />
  );
};

export default React.memo(CancelOrderModal);
